export default class NineSlice {
    constructor(scene, x, y, width, height, key = "rectangle_ombre_bleu") {
        return scene.make.nineslice({x: x, y: y, key: key, width: width, height: height, leftWidth: 60, rightWidth: 60, topHeight: 60, bottomHeight: 60, add: true})
    }
}